var config = {
    //baseUrl: `http://localhost:8090/DicomStudyListWebAPI`,
    //baseUrl: `https://localhost:5001/WebViewer`, // for localhost testing
    baseUrl: `https://dicomserver.co.uk:5001/WebViewer`, // for publish
    //baseUrl: `https://dicomserver.co.uk/WebViewerWebAPI/WebViewer`,
    useWebAPI: true,
    webapi: {
        useSQL: false,
        totalStudies: "TotalStudies",
        fetchStudyTable: "FetchStudyTable",
        fetchStudyData: "FetchStudyData",
        getImage: "GetImage",
    },
    qido: {
        root: 'qido',
        limit: "10",
        offset: "0",
    },
    wado: {
        root: 'wado',
        limit: "10",
        offset: "0",
    },
}

module.exports = config;